import {Avatar, Box, IconButton, Input, Stack, Typography} from "@mui/material";
import React, {useContext, useState} from "react";
import {IconSend, IconTrash} from "@tabler/icons-react";
import {SignInContext} from "../../../../context/SignInContext";
import {ConversationRepository} from "../../../../repositories/ConversationRepository";
import {grey} from "@mui/material/colors";
import moment from "moment";


export const ConversationComments = ({conversation, updateConversation}) => {
  const {currentUser} = useContext(SignInContext)
  const [text, setText] = useState('');

  const handleRemoveComment = (comment) => {
    if (comment?.username !== currentUser?.username) {
      return;
    }
    ConversationRepository.removeComment({id: conversation?.id, commentId: comment?.id})
      .then(() => {
        updateConversation({...conversation, comments: [...(conversation?.comments || [])?.filter(i => i?.id !== comment?.id)]})
      })
      .catch(error => console.log(error))
  }

  const handleSubmit = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (!text) {
      return;
    }
    const username = currentUser?.username || null;
    ConversationRepository.commentConversation({id: conversation?.id, username, text})
      .then(response => {
        updateConversation({...conversation, comments: [...(conversation?.comments || []), {...response?.data}]})
      })
      .catch(error => console.log(error))
    setText("");
  }

  return (
    <>
      <Stack direction={"column"} gap={2} sx={{width: "100%"}}>
        {conversation?.comments?.length === 0 ?
          <Typography>There is no comments for this conversation...</Typography> : null}

        {conversation?.comments?.map(comment => {
          return (
            <Stack key={comment?.id} direction={"row"} flexWrap={"wrap"} gap={0.5}>
              <Box>
                <Avatar sx={{width: 35, height: 35, fontSize: "0.95em", bgcolor: grey[200], color: grey[700]}}>
                  {comment?.username[0]?.toUpperCase() || ""}
                  {comment?.username[1]?.toUpperCase() || ""}
                </Avatar>
              </Box>
              <Box sx={{flex: 1, pl: 1}}>
                <Typography fontWeight={500} fontSize={13} fontFamily={"Roboto"}>{comment?.username}</Typography>
                <Typography fontSize={11} color={grey[600]} fontFamily={"Roboto"}>{moment(comment?.dateCreated).fromNow()}</Typography>
              </Box>
              {
                comment?.username === currentUser?.username &&
                <Box>
                  <IconButton onClick={() => handleRemoveComment(comment)} size={"small"}><IconTrash size={16} /></IconButton>
                </Box>
              }

              <Typography fontWeight={400} fontSize={13} sx={{width: "100%", px: 1}} fontFamily={"Roboto"}>{comment?.text}</Typography>

            </Stack>
          )
        })}
      </Stack>
      <Stack
        component={"form"} onSubmit={handleSubmit} maxWidth={"sm"} direction={"row"} gap={2}
        className={"border-shadow"}
        sx={{
          p: 2,
          borderRadius: 5,
          width: "90%",
          mb: 5,
          mx: "auto",
          bgcolor: "background.paper",
        }}
      >
        <Input
          placeholder={"Enter your comment here"} disableUnderline
          sx={{flex: 1}} maxRows={3} multiline
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault(); // prevent newline
              handleSubmit(e);    // manually submit
            }
          }}
        />
        <Box>
          <IconButton disabled={!text} type={"submit"}><IconSend/></IconButton>
        </Box>
      </Stack>
    </>
  )
}